// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__1OEZ-","closeSideBarIcon":"SideBar_closeSideBarIcon__1CV1w","Open":"SideBar_Open__ZYSRc","Close":"SideBar_Close__2rgeM"};